import type { DataBuilderSettingsSection } from '../../../DataBuilder/api/data-builder-api.types';

export type SettingsValue = NonNullable<DataBuilderSettingsSection['value']>;
export type SettingsValues = Record<string, SettingsValue>;

export const asString = (value: SettingsValue | undefined): string =>
  typeof value === 'string' ? value : '';

export const asStringArray = (value: SettingsValue | undefined): string[] =>
  Array.isArray(value) ? value : [];

export const asBool = (value: SettingsValue | undefined): boolean =>
  value === true;
